import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import * as Sentry from '@sentry/react';

// MUI
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { enGB } from 'date-fns/locale';

// Routes
import { AppRoutes } from './routes';

// Redux
import { store, persistor } from './redux/store';

// Theme
import ThemeConfig from './theme';

// Components
import RtlLayout from './components/RtlLayout';
import ProgessBar from './components/progress-bar';
import SnackbarProvider from './components/snack-bar/snackbar-provider';
import NetworkStatus from './components/NetworkStatus';
import ScrollToTop from './components/ScrollToTop';
import LoadingScreen from './components/LoadingScreen';
import GoogleAnalytics from './components/GoogleAnalytics';
import JwtProvider from './components/authentication/JwtProvider';

import { versionNumber } from './config';

const buildNumber = process.env.REACT_APP_BUILD_NUMBER || 0;

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_ENVIRONMENT,
  release: `drivecloud-fe@${versionNumber}.${buildNumber}`,
  integrations: [new Sentry.BrowserTracing()],
  tracesSampleRate: 1.0
});

const history = createBrowserHistory();

export default function App() {
  return (
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={<LoadingScreen />} persistor={persistor}>
          <ThemeConfig>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={enGB}
            >
              <NetworkStatus />
              <SnackbarProvider>
                <BrowserRouter history={history}>
                  <JwtProvider>
                    <ScrollToTop />
                    <GoogleAnalytics />
                    <ProgessBar />
                    <AppRoutes />
                  </JwtProvider>
                </BrowserRouter>
              </SnackbarProvider>
            </LocalizationProvider>
          </ThemeConfig>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  );
}
